import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from '@/utils/cx';
import useStyle from './style';

const OtpInput = ({
  validation,
  formatter,
  className,
  length,
  value,
  onChange,
  invalid,
  inputProps,
  ...rest
}) => {
  const CODE_LENGTH = new Array(length).fill(0);
  const classes = useStyle({ length });
  const inputRef = useRef(null);
  const [inputValue, setInputValue] = useState(value);
  const [focus, setFocus] = useState(false);

  const handleClick = () => {
    if (invalid) {
      setInputValue('');
    }
    inputRef.current.focus();
  };
  const handleFocus = () => {
    setFocus(true);
  };
  const handleBlur = () => {
    setFocus(false);
  };
  const handleKeyUp = (e) => {
    if (e.key === 'Backspace') {
      setInputValue((currentValue) => currentValue.slice(0, currentValue.length - 1));
    }
  };
  const handleChange = (event) => {
    // eslint-disable-next-line no-shadow
    const { value } = event.target;

    setInputValue((prevVal) => {
      if (prevVal.length >= CODE_LENGTH.length) {
        return prevVal;
      }
      return (prevVal + value).slice(0, CODE_LENGTH.length);
    });
  };

  useEffect(() => {
    onChange(inputValue);
  }, [inputValue]);

  const values = inputValue.split('');

  const selectedIndex = values.length < CODE_LENGTH.length ? values.length : CODE_LENGTH.length - 1;

  const hideInput = !(values.length < CODE_LENGTH.length);

  return (
    <div
      className={classes.otpInput}
      {...rest}
    >
      {/* eslint-disable-next-line max-len */}
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
      <div className={classes.wrap} onClick={handleClick}>
        <input
          value=""
          ref={inputRef}
          onChange={handleChange}
          onKeyUp={handleKeyUp}
          onFocus={handleFocus}
          onBlur={handleBlur}
          className={classes.input}
          inputMode="numeric"
          autoComplete="one-time-code"
          type="number"
          style={{
            width: '32px',
            top: '0px',
            bottom: '0px',
            left: `${selectedIndex * 40}px`,
            opacity: hideInput ? 0 : 1,
          }}
          {...inputProps}
          />
        {CODE_LENGTH.map((v, index) => {
          const valuesArr = inputValue.split('');
          const selected = valuesArr.length === index;
          const filled = valuesArr.length === CODE_LENGTH.length
              && index === CODE_LENGTH.length - 1;

          return (
            <div
              className={cx(
                classes.display,
                index < valuesArr.length && 'fill',
                (selected || filled) && focus && 'focused',
                invalid && 'invalid',
              )}
              key={index}>
              {values[index]}
            </div>
          );
        })}
      </div>
    </div>

  );
};

OtpInput.propTypes = {
  length: PropTypes.number,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  invalid: PropTypes.bool,
  inputProps: PropTypes.shape(),
};

OtpInput.defaultProps = {
  value: '',
  length: 6,
  invalid: false,
  inputProps: {},
};

export default OtpInput;
